export default __webpack_public_path__ + "static/media/Fraud.0a743cfc.svg";